import expand_less from '@/common/assets/icons/material/sharp/expand_less.svg';
import expand_more from '@/common/assets/icons/material/sharp/expand_more.svg';
import layers from '@/common/assets/icons/material/sharp/layers.svg';
import partly_cloudy_day from '@/common/assets/icons/material/sharp/partly_cloudy_day.svg';
import pause from '@/common/assets/icons/material/sharp/pause.svg';
import replay from '@/common/assets/icons/material/sharp/replay.svg';
import search from '@/common/assets/icons/material/sharp/search.svg';

import layers_fill from '@/common/assets/icons/material/sharp/fill/layers_fill.svg';
import pause_fill from '@/common/assets/icons/material/sharp/fill/pause_fill.svg';

export const symbolsMap: Record<string, string> = {
  expand_less,
  expand_more,
  layers,
  partly_cloudy_day,
  pause,
  replay,
  search,
};

export const filledSymbolsMap: Record<string, string> = {
  layers: layers_fill,
  pause: pause_fill,
};

export const sizes = ['2xs', 'xs', 'sm', 'md', 'lg', 'xl', 'custom'] as const;
export const weights = ['200', '300'] as const;
export const grades = ['-25', '0', '200'] as const;
